import React from "react";
import { cn } from "../utils";
import { border, typography } from "../tokens";
import { useStableKpiValue } from "../../../utils/useStableKpiValue";

const kpiValueStyle = {
  fontVariantNumeric: "tabular-nums",
  minWidth: "1.5ch",
  display: "inline-block",
};

export function CompactStatCard({ label, value, valueClassName = "text-gray-800", bg = "bg-gray-50", className }) {
  const stableValue = useStableKpiValue(value);
  return (
    <div className={cn(bg, "rounded-xl p-4", className)} style={{ border: border.card }}>
      <p className="text-gray-500" style={typography.subtitle}>{label}</p>
      <p className={cn(valueClassName, "mt-1")} style={{ ...typography.statValue, fontWeight: 700, ...kpiValueStyle }}>
        {stableValue}
      </p>
    </div>
  );
}

export function CompactStatGrid({ children, cols = "grid-cols-2 lg:grid-cols-4", className }) {
  return <div className={cn("grid gap-4", cols, className)}>{children}</div>;
}

export function InlineStatCard({ label, value, icon: Icon, iconBg = "bg-indigo-50", iconColor = "text-blue-600", valueClassName = "text-blue-600" }) {
  const stableValue = useStableKpiValue(value);
  return (
    <div className="bg-white rounded-xl shadow-sm p-4 flex items-center gap-3" style={{ border: border.card }}>
      <div className={cn("w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0", iconBg)}>
        <Icon className={cn("w-5 h-5", iconColor)} />
      </div>
      <div>
        <p className="text-gray-400" style={typography.statLabel}>{label}</p>
        <p className={valueClassName} style={{ fontSize: "1.4rem", fontWeight: 700, lineHeight: 1.2, ...kpiValueStyle }}>
          {stableValue}
        </p>
      </div>
    </div>
  );
}
